import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/perpetuity-calculator',
  component: () => import('../../routes/PerpetuityCalculator.svelte'),
  card: {
    id: 'perpetuity-calculator',
    title: 'Perpetuity Calculator',
    description: 'Calculate the present value of a perpetuity — a stream of payments that lasts forever. Supports fixed payments and growing payments (Gordon Growth Model).',
    icon: 'all_inclusive',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/perpetuity-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Perpetuity Calculator – Present Value of a Perpetuity',
    description: 'Free perpetuity calculator to find the present value of a forever-paying investment. Calculate fixed and growing perpetuities using the Gordon Growth Model. Perfect for dividend investing and valuation.',
  },
};

export default meta;
